module.exports = __webpack_public_path__ + "static/lato-regular-d1d5e30aa8bb081cad8f409f27861672.ttf";